import { Bell } from 'lucide-react';

const NotificationBadge = ({ count, onClick }) => (
  <button onClick={onClick} className="relative p-1.5 text-[#8a8577] hover:text-[#e8e4de] transition-colors" aria-label={`${count} notificaciones no leídas`}>
    <Bell className="w-5 h-5" />
    {count > 0 && (
      <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-[#c75d5d] text-white text-[10px] font-medium px-1">
        {count > 99 ? '99+' : count}
      </span>
    )}
  </button>
);

export default NotificationBadge;
